// Safely coerce any thrown value into a human-readable string for toast/UI.
// Sonner renders the value as a React child, so passing an Error object or
// a structured error payload directly triggers React #31.
export function errorMessage(value: unknown, fallback?: string): string {
  if (value == null) return fallback ?? 'Something went wrong';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);

  if (typeof value === 'object') {
    const v = value as Record<string, unknown>;
    if (typeof v.message === 'string') return v.message;
    if (typeof v.error === 'string') return v.error;
    if (typeof v.error === 'object' && v.error != null) {
      const e = v.error as Record<string, unknown>;
      if (typeof e.message === 'string') return e.message;
    }
    try {
      const json = JSON.stringify(value);
      if (json && json !== '{}') return json;
    } catch {
      // fall through
    }
  }

  return fallback ?? 'Something went wrong';
}
